var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-ad-material-edit","toptitle":"Werbemittel bearbeiten","title":_vm.projectAdMaterial.name,"width":800}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-ad-material-form',{attrs:{"projectAdMaterial":_vm.projectAdMaterial,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }